module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step1c_Image5i.ce0760a3.jpg";